<template>
    <div class="frontInfo">
        <div class="cumulativeInfo">
            <!-- <div class="frontPic">
                <div class="cumulativeRotate"></div>
                <img src="../assets/gif/pave.gif" alt="" />
            </div> -->
            <div class="currentMaterial">当日累计摊铺</div>
            <div class="layerList" v-if="type == 'lq'">
                <div class="layer" v-if="paveCurrentDay.up">
                    上面层 :
                    <el-tooltip :content="paveCurrentDay.up" placement="top" effect="dark">
                        <span>{{ paveCurrentDay.up }}</span>
                    </el-tooltip>
                </div>
                <div class="layer" v-if="paveCurrentDay.middle">
                    中面层 :
                    <el-tooltip :content="paveCurrentDay.middle" placement="top" effect="dark">
                        <span>{{ paveCurrentDay.middle }}</span>
                    </el-tooltip>
                </div>
                <div class="layer" v-if="paveCurrentDay.down">
                    下面层 :
                    <el-tooltip :content="paveCurrentDay.down" placement="top" effect="dark">
                        <span>{{ paveCurrentDay.down }}</span>
                    </el-tooltip>
                </div>
            </div>
            <div class="layerList" v-if="type == 'sw'">
                <div class="layer" v-if="paveCurrentDay.up">
                    上基层 :
                    <el-tooltip :content="paveCurrentDay.up" placement="top" effect="dark">
                        <span>{{ paveCurrentDay.up }}</span>
                    </el-tooltip>
                </div>
                <div class="layer" v-if="paveCurrentDay.middle">
                    下基层 :
                    <el-tooltip :content="paveCurrentDay.middle" placement="top" effect="dark">
                        <span>{{ paveCurrentDay.middle }}</span>
                    </el-tooltip>
                </div>
                <div class="layer" v-if="paveCurrentDay.down">
                    底基层 :
                    <el-tooltip :content="paveCurrentDay.down" placement="top" effect="dark">
                        <span>{{ paveCurrentDay.down }}</span>
                    </el-tooltip>
                </div>
            </div>
        </div>
        <div class="realTimeInfo">
            <!-- <div class="realTimePic">
                <img class="realTimeRotate" src="../assets/img/111.png" alt="" />
            </div> -->
            <div class="currentMaterial2">{{ pavingStatus == 2 ? '最后施工数据' : '实时数据' }}</div>
            <div class="realTimeCon">
                <div class="deviceArea" :class="{ 'has-arrows': showDeviceArrows }">
                    <span
                        v-show="showDeviceArrows"
                        class="deviceArrow deviceArrow--left"
                        @click="prevDevicePage"
                    ></span>
                    <el-row class="deviceRow">
                        <el-col
                            v-for="item in visibleDeviceList"
                            :key="item.key"
                            :span="8"
                        >
                            <div class="pre">
                                <div class="deviceHead">
                                    <div class="deviceIcon">
                                        <img v-if="item.icon" :src="item.icon" alt="" />
                                    </div>
                                    <div class="deviceNameWrap">
                                        <el-tooltip :content="item.typeName" placement="top" effect="dark">
                                            <div class="deviceName">{{ item.typeName }}</div>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <div class="someInfo">
                                    <div v-if="type == 'lq'">温度 :
                                        <span>{{ item.temp ? item.temp + '°C' : '-/-' }}</span></div>
                                    <div :class="type == 'sw' ? 'swMargin' : ''">
                                        速度 : <span>{{ item.speed ? item.speed + item.speedUnit : '-/-' }}</span>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <span
                        v-show="showDeviceArrows"
                        class="deviceArrow deviceArrow--right"
                        @click="nextDevicePage"
                    ></span>
                </div>
                <el-row class="envRow" :class="{ 'has-arrows': showDeviceArrows }">
                    <el-col :span="8">
                        <div class="envInfo">
                            风速 :
                            <span>{{ frontInfo.windSpped != 0 ? frontInfo.windSpped + 'km/h' : '-/-' }}</span>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="envInfo">
                            温度 :
                            <span>{{ frontInfo.temp != 0 ? frontInfo.temp + '°C' : '-/-' }}</span>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="envInfo">
                            湿度 :
                            <span>{{ frontInfo.humidity != 0 ? frontInfo.humidity + '%' : '-/-' }}</span>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import {
    getFrontWork,
    getInitScreenData,
    getLastPaveTimeByWorkArea
} from "@/api/api";
export default {
    props: {
        type: "",
    },
    data() {
        return {
            frontInfo: {
                windSpped: "",
                temp: "",
                humidity: ""
            },
            paveInfo: {
                temp: "",
                speed: "",
                tempSeg: "",
            },
            rollerInfoList: [],
            devicePageIndex: 0,
            devicePageSize: 3,
            paveCurrentDay: {
                up: "",
                middle: "",
                down: ""
            },
            pavingStatus: null,
            intervalId: null,
        };
    },
    created() {
        this.dataRefreh();
    },
    beforeDestroy() {
        this.clear();
    },
    methods: {
        dataRefreh() {
            if (this.intervalId != null) {
                return;
            }
            this.intervalId = setInterval(() => {
                this.getTW();
                this.getFrontWorkInfo();
            }, 30000);
        },
        clear() {
            clearInterval(this.intervalId);
            this.intervalId = null;
        },
        resetData() {
            this.resetEnvData()
            this.resetPaveData()
            this.pavingStatus = null
        },
        resetEnvData() {
            this.frontInfo = {
                windSpped: "",
                temp: "",
                humidity: ""
            }
        },
        resetPaveData() {
            this.paveInfo = {
                temp: "",
                speed: "",
                tempSeg: "",
            }
            this.rollerInfoList = []
            this.devicePageIndex = 0
            this.paveCurrentDay = {
                up: "",
                middle: "",
                down: ""
            }
        },
        refreshAll() {
            this.getTW();
            this.getFrontWorkInfo();
        },
        clampDevicePage() {
            if (this.devicePageIndex > this.devicePageCount - 1) {
                this.devicePageIndex = 0
            }
        },
        prevDevicePage() {
            if (!this.showDeviceArrows) return
            this.devicePageIndex = (this.devicePageIndex - 1 + this.devicePageCount) % this.devicePageCount
        },
        nextDevicePage() {
            if (!this.showDeviceArrows) return
            this.devicePageIndex = (this.devicePageIndex + 1) % this.devicePageCount
        },
        getDeviceIcon(typeName) {
            const name = typeName || ''
            if (name.indexOf('摊铺') >= 0) {
                return require('../assets/img/qctp.png')
            }
            if (name.indexOf('钢') >= 0) {
                return require('../assets/img/qcgl.png')
            }
            if (name.indexOf('胶') >= 0) {
                return require('../assets/img/qcjl.png')
            }
            return ''
        },
        NumberFix(val) {
            const y = val.getFullYear();
            const m = (val.getMonth() + 1).toString().padStart(2, "0");
            const d = val.getDate().toString().padStart(2, "0");
            const h = val.getHours().toString().padStart(2, "0");
            const mi = val.getMinutes().toString().padStart(2, "0");
            const s = val.getSeconds().toString().padStart(2, "0");
            return `${y}-${m}-${d} ${h}:${mi}:${s}`;
        },
        async getTW() {
            if (!this.sectionId) {
                this.resetEnvData()
                return
            }
            let req = {
                engineeringConfigId: this.sectionId
            };
            const ertData = await getInitScreenData(req);
            if (ertData.status == 200) {
                const env = (ertData.data && ertData.data.resultData) || {}
                this.frontInfo = {
                    windSpped: Number(env.windSpeed || 0).toFixed(0),
                    temp: Number(env.envTemperature || 0).toFixed(0),
                    humidity: Number(env.envHumidity || 0).toFixed(0)
                }
            }
        },
        async getFrontWorkInfo() {
            if (!this.sectionId) {
                this.resetPaveData()
                this.pavingStatus = null
                return
            }
            const paveRes = await getLastPaveTimeByWorkArea({
                workAreaId: this.sectionId
            })
            const paveBody = paveRes && paveRes.data
            const pavePayload = (paveBody && paveBody.resultData != null)
                ? paveBody.resultData
                : paveBody
            let paveTime = ''
            this.pavingStatus = null
            if (typeof pavePayload === 'string' || typeof pavePayload === 'number') {
                paveTime = pavePayload
            } else if (pavePayload && typeof pavePayload === 'object') {
                paveTime = pavePayload.paveTime || ''
                this.pavingStatus = pavePayload.pavingStatus
            }
            if (!paveTime) {
                this.resetPaveData()
                return
            }
            const dateAfter = new Date(String(paveTime).replace(/-/g, '/'))
            if (isNaN(dateAfter.getTime())) {
                this.resetPaveData()
                return
            }
            const dateBefore = new Date(dateAfter.getTime() - 1 * 60 * 60 * 1000)
            let endDateTime = this.NumberFix(dateAfter)
            let startDateTime = this.NumberFix(dateBefore)
            let req = {
                endDateTime: endDateTime,
                materialType: this.type,
                sectionId: this.seIds,
                startDateTime: startDateTime,
                workAreaId: this.sectionId
            }
            const fwiDataLQ = await getFrontWork(this.type, req);
            if (fwiDataLQ.data.countMileByLayer.layers != null) {
                if (this.type == 'lq') {
                    this.paveCurrentDay = {
                        up: fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "上面层")[0] && fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "上面层")[0].value > 0 ? fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "上面层")[0].value + "km （" + fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "上面层")[0].plug + "）" : "",
                        middle: fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "中面层")[0] && fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "中面层")[0].value > 0 ? fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "中面层")[0].value + "km （" + fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "中面层")[0].plug + "）" : "",
                        down: fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "下面层")[0] && fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "下面层")[0].value > 0 ? fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "下面层")[0].value + "km （" + fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "下面层")[0].plug + "）" : ""
                    }
                } else {
                    this.paveCurrentDay = {
                        up: fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "上基层")[0] && fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "上基层")[0].value > 0 ? fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "上基层")[0].value + "km （" + fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "上基层")[0].plug + "）" : "",
                        middle: fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "下基层")[0] && fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "下基层")[0].value > 0 ? fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "下基层")[0].value + "km （" + fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "下基层")[0].plug + "）" : "",
                        down: fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "底基层")[0] && fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "底基层")[0].value > 0 ? fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "底基层")[0].value + "km （" + fwiDataLQ.data.countMileByLayer.layers.filter(item => item.name == "底基层")[0].plug + "）" : ""
                    }
                }
            } else {
                this.paveCurrentDay = {
                    up: "",
                    middle: "",
                    down: ""
                }
            }

            this.paveInfo = {
                temp: fwiDataLQ.data.paverAvgInfo.temp,
                speed: fwiDataLQ.data.paverAvgInfo.speed,
                tempSeg: fwiDataLQ.data.paverAvgInfo.tempSeg,
            }
            const rollerAvgInfo = (fwiDataLQ.data && fwiDataLQ.data.rollerAvgInfo) || []
            this.rollerInfoList = rollerAvgInfo.map(item => ({
                typeName: item.typeName || '',
                temp: item.temp,
                speed: item.speed
            }))
            this.clampDevicePage()
        },
    },
    computed: {
        ...mapState(["sectionId", "seIds", "engineerId"]),
        deviceList() {
            const list = [{
                key: 'pave',
                typeName: '摊铺',
                icon: this.getDeviceIcon('摊铺'),
                temp: this.paveInfo.temp,
                speed: this.paveInfo.speed,
                speedUnit: 'm/min'
            }]
            this.rollerInfoList.forEach((item, index) => {
                list.push({
                    key: 'roller-' + index,
                    typeName: item.typeName,
                    icon: this.getDeviceIcon(item.typeName),
                    temp: item.temp,
                    speed: item.speed,
                    speedUnit: 'km/h'
                })
            })
            return list
        },
        devicePageCount() {
            return Math.max(1, Math.ceil(this.deviceList.length / this.devicePageSize))
        },
        visibleDeviceList() {
            const start = this.devicePageIndex * this.devicePageSize
            return this.deviceList.slice(start, start + this.devicePageSize)
        },
        showDeviceArrows() {
            return this.deviceList.length > this.devicePageSize
        }
    },
    watch: {
        sectionId: {
            handler(curVal, oldVal) {
                if (!curVal || curVal === oldVal) return
                this.$nextTick(() => {
                    this.refreshAll()
                })
            },
            immediate: true
        },
        engineerId(curVal, oldVal) {
            if (curVal === oldVal) return
            this.resetData()
        },
    },
};
</script>
<style lang="less" scoped>
.frontInfo {
    position: relative;
    width: 100%;
    height: 100%;
    right: auto;
    top: auto;
    box-sizing: border-box;

    .currentMaterial,
    .currentMaterial2 {
        position: relative;
        text-align: center;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 700;
        color: #ffffff;
        height: 36px;
        line-height: 36px;
        margin-left: 0;
        background: linear-gradient(
            90deg,
            transparent 0%,
            rgba(20, 58, 140, 0.55) 22%,
            rgba(28, 78, 180, 0.85) 50%,
            rgba(20, 58, 140, 0.55) 78%,
            transparent 100%
        );
        background-size: 50% 100%;
        background-position: center;
        background-repeat: no-repeat;

        &::after {
            content: "";
            position: absolute;
            left: 50%;
            bottom: 0;
            width: 46%;
            height: 1px;
            transform: translateX(-50%);
            background: linear-gradient(
                90deg,
                transparent 0%,
                rgba(45, 252, 251, 0.25) 12%,
                #18ffff 50%,
                rgba(45, 252, 251, 0.25) 88%,
                transparent 100%
            );
            box-shadow: 0 0 6px rgba(24, 255, 255, 0.55);
        }
    }

    .cumulativeInfo {
        position: absolute;
        margin-top: 0;
        top: 0;
        left: 0;
        width: 100%;
        height: 45%;
        display: flex;
        flex-direction: column;
        // background-image: url(../assets/img/cumulativePaving@2x.png);
        background-size: 100% 100%;

        .frontPic {
            position: absolute;
            bottom: 0px;
            left: -24px;
            width: 50px;
            height: 50px;
            border-radius: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-image: url(../assets/img/ring@2x.png);
            background-size: 100% 100%;

            .cumulativeRotate {
                position: absolute;
                left: 0;
                width: 25px;
                height: 10px;
                transform-origin: right center;
                animation: cumulativeRotate 5s linear infinite;

                &::before {
                    position: absolute;
                    content: "";
                    left: 1px;
                    width: 5px;
                    height: 5px;
                    border-radius: 5px;
                    box-shadow: 0px 0px 3px #44e6ff;
                    background-color: #44e6ff;
                }
            }
        }

        .layerList {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding-bottom: 6px;
        }

        .layer {
            margin-top: 2px;
            margin-left: 24px;
            margin-right: 16px;
            line-height: 20px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;

            span {
                display: inline-block;
                max-width: 360px;
                line-height: 16px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                color: #44f8ff;
                vertical-align: top;
                cursor: pointer;
            }
        }
    }

        .realTimeInfo {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 58%;
        text-align: center;
        display: flex;
        flex-direction: column;
        // background-image: url(../assets/img/real-time@2x.png);
        background-size: 100% 100%;

        .realTimePic {
            position: absolute;
            top: -6px;
            left: -24px;
            width: 50px;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-size: 100% 100%;

            .realTimeRotate {
                width: 98%;
                height: 98%;
                animation: realTimeRotate 5s linear infinite;
            }
        }

        .realTimeCon {
            flex: 1;
            min-height: 0;
            width: 100%;
            margin-top: 4px;
            padding-left: 0;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;

            .el-row {
                font-size: 12px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #ffffff;

                [class*="el-col"] {
                    text-align: left;
                    padding-left: 8px;
                    padding-right: 4px;
                    box-sizing: border-box;
                }
            }

            .deviceArea {
                position: relative;
                flex: 1;
                min-height: 0;
            }

            .has-arrows {
                padding: 0 16px;
                box-sizing: border-box;
            }

            .deviceArrow {
                position: absolute;
                top: 54%;
                width: 16px;
                height: 28px;
                margin-top: -14px;
                cursor: pointer;
                z-index: 2;

                &::before {
                    content: "";
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    width: 0;
                    height: 0;
                    transform: translate(-50%, -50%);
                }

                &--left {
                    left: 0;

                    &::before {
                        border-top: 5px solid transparent;
                        border-bottom: 5px solid transparent;
                        border-right: 7px solid #44c1ff;
                    }
                }

                &--right {
                    right: 0;

                    &::before {
                        border-top: 5px solid transparent;
                        border-bottom: 5px solid transparent;
                        border-left: 7px solid #44c1ff;
                    }
                }
            }

            .deviceRow {
                flex: 1;

                span {
                    color: #fff721;
                }

                .pre {
                    overflow: hidden;
                    margin-top: 4px;
                }

                .deviceHead {
                    display: flex;
                    align-items: center;
                    height: 36px;
                }

                .deviceIcon {
                    flex-shrink: 0;
                    width: 42px;
                    height: 42px;
                    // margin-right: 4px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    // background-image: url(../assets/img/data-rolle-frame@2x.png);
                    background-size: 100% 100%;
                    background-repeat: no-repeat;

                    img {
                        width: 72%;
                        height: 72%;
                        object-fit: contain;
                    }
                }

                .deviceNameWrap {
                    flex: 1;
                    min-width: 0;
                    height: 28px;

                    /deep/ .el-tooltip {
                        display: block;
                        width: 100%;
                    }
                }

                .deviceName {
                    width: 100%;
                    height: 28px;
                    line-height: 28px;
                    padding: 0 8px 0 6px;
                    box-sizing: border-box;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    font-size: 13px;
                    color: #ffffff;
                    background: url(../assets/img/data-rolle-frame@2x.png) no-repeat;
                    background-size: 100% 100%;
                }

                .someInfo {
                    margin-top: 6px;
                    line-height: 20px;
                    text-align: left;
                }
            }

            .envRow {
                flex-shrink: 0;
                margin-top: 10px;

                .envInfo {
                    padding-bottom: 6px;
                    color: #ffffff;

                    span {
                        color: #ffffff;
                    }
                }
            }
        }
    }

    .swMargin {
        padding-top: 10px;
    }
}

@keyframes realTimeRotate {
    from {
        transform: rotate(0deg)
    }

    to {
        transform: rotate(359deg)
    }
}

@keyframes cumulativeRotate {
    from {
        transform: rotate(0deg)
    }

    to {
        transform: rotate(359deg)
    }
}
</style>



// WEBPACK FOOTER //
// src/subassembly/frontInfo.vue